export enum PaymentFailCode {
  InsufficientFunds = 1,
  IncorectData = 2,
  TryAgain = 3,
  TransactionRefused = 4,
}

export const TextByError = {
  [PaymentFailCode.InsufficientFunds]: 'Недостаточно средств на карте',
  [PaymentFailCode.IncorectData]: 'Некорректные данные карты',
  [PaymentFailCode.TryAgain]: 'Попробуйте ещё раз',
  [PaymentFailCode.TransactionRefused]: 'Ваш банк отклонил операцию',
}

// sessionStorage flag: the payment form left the site via a full-page redirect (e.g. T-Pay via T-ID)
export const PAYMENT_EXTERNAL_REDIRECT_KEY = 'payment-external-redirect'

export const getPaymentFailCode = (tinkoffErrorCode: number): PaymentFailCode => {
  if (tinkoffErrorCode === 1051) {
    return PaymentFailCode.InsufficientFunds
  }
  if (
    [ 99, 1057, 1065, 1089 ].includes(tinkoffErrorCode) ||
    (tinkoffErrorCode > 1034 && tinkoffErrorCode < 1043)
  ) {
    return PaymentFailCode.TransactionRefused
  }
  if ([ 219, 231, 244, 252, 1006, 1012, 1014, 101, 1033, 1054, 1082, 1091 ].includes(tinkoffErrorCode)) {
    return PaymentFailCode.IncorectData
  }
  return PaymentFailCode.TryAgain
}
